import { useEffect } from "react";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { Add } from "@mui/icons-material";
import { Button, FormControl, FormLabel, Stack } from "@mui/material";
import AddOrEditTemplate from "./AddOrEditTemplate";
import useBoolean from "../../hooks/useBoolean";
import PageTitle from "../../common/PageTitle";
import BasicDrawer from "../../global/Drawer/BasicDrawer";
import { EMPLOYER_TEMPLATE_TYPE, EMPLOYER_TEMPLATE_TYPE_LIST } from "../../helpers/constant/employerTemplateConstant";
import { addEmployerTemplateType, resetEmployerTemplateFilter, setCategoryForTemplate } from "../../state/employerTemplate/employerTemplateSlice";
import BasicModalWithHeader from "../../global/Modal/BasicModalWithHeader";
import CreateTemplateCategory from "./CreateTemplateCategory";
import { useNavigate } from "react-router-dom";

const TemplatesHeader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { value: openDrawer, setTrue: onOpenDrawer, setFalse: onCloseDrawer } = useBoolean(false);
  const { value: openCategoryModal, setTrue: onOpenCategoryModal, setFalse: onCloseCategoryModal } = useBoolean(false);

  const handleChangeType = (newValue) => {
    dispatch(addEmployerTemplateType(newValue.value));
  };

  const onSubmit = (data) => {
    onCloseCategoryModal();
    dispatch(setCategoryForTemplate({ category: data?.category?.value }));
    if (Number(data?.category?.value) === EMPLOYER_TEMPLATE_TYPE.FOR_DOCUMENTS) {
      navigate("/dashboard/docuemt-template");
    } else {
      onOpenDrawer();
    }
  };

  useEffect(() => {
    return () => dispatch(resetEmployerTemplateFilter());
  }, []);

  let categoryOptions = Object.values(EMPLOYER_TEMPLATE_TYPE_LIST);
  categoryOptions = [{ label: "All", value: "" }, ...categoryOptions];
  return (
    <>
      <Stack direction={"row"} alignItems={"end"} justifyContent={"space-between"} mb={3}>
        <PageTitle title={"Employer Templates"} subTitle={"Templates for employer. Any employer can use our template."} mb={0} />
        <Stack direction={"row"} alignItems={"end"} spacing={2}>
          <FormControl sx={{ width: 300 }}>
            <FormLabel>Filter By Category:</FormLabel>
            <Select
              className={"select-dropdown-menu select-dropdown-menu-custom"}
              classNamePrefix={"select-dropdown-styles"}
              isMulti={false}
              isSearchable={false}
              menuPlacement="bottom"
              options={categoryOptions}
              onChange={handleChangeType}
            />
          </FormControl>

          <Button variant={"contained"} size={"small"} endIcon={<Add />} onClick={onOpenCategoryModal}>
            Add Template
          </Button>
        </Stack>
      </Stack>

      <BasicModalWithHeader title={"Create New template"} open={openCategoryModal} onClose={onCloseCategoryModal} width={400}>
        <CreateTemplateCategory onClose={onCloseCategoryModal} onSubmit={onSubmit} />
      </BasicModalWithHeader>

      <BasicDrawer title={"Add New Template"} open={openDrawer} onClose={onCloseDrawer}>
        <AddOrEditTemplate isEdit={false} onClose={onCloseDrawer} />
      </BasicDrawer>
    </>
  );
};

export default TemplatesHeader;
